import { i18n } from '@/shared/i18n';

export const getThreatConfig = (threat?: string) => {
  const normalized = threat?.toLowerCase() ?? '';
  if (normalized.includes('high')) {
    return {
      // eslint-disable-next-line i18next/no-literal-string -- Badge variant name from the design system
      variant: 'destructive' as const,
      label: i18n.t('analysis:analysisResult.competitiveAnalysis.highThreat'),
    };
  }
  if (normalized.includes('medium')) {
    return {
      // eslint-disable-next-line i18next/no-literal-string -- Badge variant name from the design system
      variant: 'warning' as const,
      label: i18n.t('analysis:analysisResult.competitiveAnalysis.mediumThreat'),
    };
  }
  return {
    // eslint-disable-next-line i18next/no-literal-string -- Badge variant name from the design system
    variant: 'positive' as const,
    label: i18n.t('analysis:analysisResult.competitiveAnalysis.lowThreat'),
  };
};
